export default "__VITE_ASSET__DE$LjBNd__"